import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Mia from "./Birthdays/2021/Mia/Mia";

function App() {
  return (
    // coppied from https://reactrouter.com/web/guides/quick-start
    <Router>
      <div>
        {/* <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/users">Users</Link>
            </li>
          </ul>
        </nav> */}

        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          {/* <Route path="/about">
            <About />
          </Route> */}
          <Route path="/mia/2021">
            <Mia />
          </Route>
          <Route path="/">
            <>Hello World</>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
